import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
import makeQueryKey from "../../../../utils/make-query-key";
export var FULFILLMENT_OFFERINGS_QUERY_KEY = 'buy/fulfillment-offerings/v1';
var getFulfillmentOfferingsQueryKey = function getFulfillmentOfferingsQueryKey(_ref) {
  var _getWebShellClientLoc;
  var skuId = _ref.skuId,
    productId = _ref.productId,
    postalCode = _ref.postalCode,
    locationId = _ref.locationId,
    offeringTypes = _ref.offeringTypes;
  var resolvedSkuId = skuId || undefined;
  var resolvedProductId = resolvedSkuId ? undefined : productId;
  return makeQueryKey([FULFILLMENT_OFFERINGS_QUERY_KEY, {
    countryCode: (_getWebShellClientLoc = getWebShellClientLocale()) === null || _getWebShellClientLoc === void 0 || (_getWebShellClientLoc = _getWebShellClientLoc.country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase(),
    skuId: resolvedSkuId,
    productId: resolvedProductId,
    postalCode: postalCode,
    locationId: locationId,
    offeringTypes: offeringTypes
  }]);
};
export default getFulfillmentOfferingsQueryKey;